import { cn, cva, type VariantProps } from 'noddi-ui-common';
import { ComponentProps } from 'react';

// bg-skeleton, a brand-hued fill: a neutral gray vanished on tinted brand pages (1.02:1 on Noddi's
// lilac), and a near-white one reads as a real card. See --skeleton in index.css.
const noddiSkeletonVariants = cva('animate-pulse bg-skeleton', {
  variants: {
    variant: {
      card: 'rounded-xl',
      button: 'rounded-md'
    }
  },
  defaultVariants: {
    variant: 'card'
  }
});

type NoddiSkeletonProps = ComponentProps<'div'> & VariantProps<typeof noddiSkeletonVariants>;

export function NoddiSkeleton({ className, variant, ...props }: NoddiSkeletonProps) {
  return <div data-slot='skeleton' className={cn(noddiSkeletonVariants({ variant }), className)} {...props} />;
}
